// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/client/modules/prescribe/modules/prescribe-view/components/prescribe-kpi/prescribe-kpi.less
// module id = 3836
// module chunks = 0